"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.env = void 0;
const is_browser_1 = require("./utils/is-browser");
/**
 * Reads a safe environment variable from the browser or any environment
 * variable from the server (process.env).
 */
function env(key) {
    if ((0, is_browser_1.isBrowser)()) {
        // eslint-disable-next-line no-underscore-dangle
        return window.__ENV[key];
    }
    return process.env[key];
}
exports.env = env;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2Vudi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtREFBK0M7QUFFL0M7OztHQUdHO0FBQ0gsU0FBZ0IsR0FBRyxDQUFDLEdBQVc7SUFDN0IsSUFBSSxJQUFBLHNCQUFTLEdBQUUsRUFBRTtRQUNmLGdEQUFnRDtRQUNoRCxPQUFPLE1BQU0sQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7S0FDMUI7SUFFRCxPQUFPLE9BQU8sQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUM7QUFDMUIsQ0FBQztBQVBELGtCQU9DIn0=